import { render } from "./BusinessPartnersPage.vue?vue&type=template&id=2a8d59d2"
import script from "./BusinessPartnersPage.vue?vue&type=script&lang=js"
export * from "./BusinessPartnersPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__